import {SET_MENU_ITEM_INDICATOR, SET_SELECTED_MENU_ITEM} from "../../actions/menu/menuAction";
import menuDefinition from "./menuDefinition";
import {GET_USER_DETAILS_SUCCESS} from "../../actions/user/platformUserAction";
import {CurrentUser} from "../../services/CurrentUser";

function attachUIProps(menuDef) {
    return menuDef.map(menu => {
        let m = {...menu, expanded: false, selected: false};


        m.menus = menu.menus !== undefined
            ? menu.menus.map(subMenu => {
                return {...subMenu, selected: false};
            })
            : undefined;

        return m;
    });
}

const initialState = {
    items: [...attachUIProps(menuDefinition)]
};

export default function menuReducer(state = initialState, action) {

    const selectSubMenuItem = (subMenuList, indexOfItemToBeSelected) => {
        const limit = subMenuList.length;
        for (let counter = 0; counter < limit; counter++) {
            subMenuList.splice(
                counter,
                1,
                {...subMenuList[counter], selected: (counter === indexOfItemToBeSelected)});
        }
    };

    const handleTopLevelSelected = (topLevelMenu) => {
        topLevelMenu.expanded = true;
        topLevelMenu.selected = true;

        if (topLevelMenu.menus.length > 0) {
            selectSubMenuItem(topLevelMenu.menus, 0);
        }
    };

    const handleSubMenuSelection = (topLevelMenu) => {
        const subMenuItemIndex= topLevelMenu.menus.findIndex(subMenu => {
            return subMenu.id === action.id;
        });

        if (subMenuItemIndex >= 0) {
            selectSubMenuItem(topLevelMenu.menus, subMenuItemIndex);
            topLevelMenu.expanded = true;
            topLevelMenu.selected = true;
        }else {
            topLevelMenu.expanded = false;
            topLevelMenu.selected = false;
        }
    };

    const handleMenuNotSelected = (topLevelMenu) => {
        topLevelMenu.expanded = false;
        topLevelMenu.selected = false;
    };

    switch (action.type) {
        case GET_USER_DETAILS_SUCCESS: {

            return {
                ...state,
                    items: state.items.filter(item => {
                        if (item.requiredRoles === undefined) {
                            return true;
                        }else if (item.requiredRoles.length === 0) {
                            return true;
                        }
                        return item.requiredRoles.find(rr => rr.toLowerCase() === CurrentUser.applicationRole.toLowerCase()) !== undefined;
                    })
            };
        }

        case SET_SELECTED_MENU_ITEM: {

            const list = [...state.items];

            const workingCopy = list.map(topLevelMenu => {
                let topLevelMenuCopied = {...topLevelMenu};
                topLevelMenuCopied.menus = [...topLevelMenu.menus];

                if (topLevelMenuCopied.id === action.id) {
                    handleTopLevelSelected(topLevelMenuCopied);
                }
                else if (topLevelMenuCopied.menus !== undefined && topLevelMenuCopied.menus.length > 0) {
                    handleSubMenuSelection(topLevelMenuCopied);
                }
                else {
                    handleMenuNotSelected(topLevelMenuCopied);
                }

                return topLevelMenuCopied;
            });

            return {...state, items: [...workingCopy]};
        }

        case SET_MENU_ITEM_INDICATOR: {
            return {
                ...state,
                items: state.items.map(setMenuItemShowIndicator(action.id, action.count))
            };
        }
        default:
            return state;
    }
}


const setMenuItemShowIndicator = (id, count) => item => {
    if (item.id === id) {
        return {...item, showIndicator: count > 0, indicatorCount: count};
    }
    if (item.menus && item.menus.length > 0) {
        return {...item, menus: item.menus.map(setMenuItemShowIndicator(id, count))};
    }
    return item;
};
